import { render } from "./NavbarEdit.vue?vue&type=template&id=c7bd0c4a"
import script from "./NavbarEdit.vue?vue&type=script&lang=js"
export * from "./NavbarEdit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__